module.exports = '3.9.0';



// WEBPACK FOOTER //
// ./src/version.js